import Box, { BoxProps } from '@mui/material/Box';

export default function CardLabel(props: BoxProps) {
  const { children } = props;

  return (
    <Box
      component="span"
      {...props}
      sx={{
        display: 'inline',
        fontWeight: 'bold',
      }}
    >
      {children}
    </Box>
  );
}
